import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}

export const SOCIETEVALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(false, [Validators.maxLength(7), Validators.required])],
    ['libelle', new FormInfo(false, [Validators.maxLength(30)])],
    ['codeStar', new FormInfo(false, [Validators.maxLength(6)])],
    ['codeCompta', new FormInfo(false, [Validators.maxLength(12)])],
    ['capitalSocial', new FormInfo(false, [Validators.maxLength(50)])],
    ['rsc', new FormInfo(false, [Validators.maxLength(50)])],
    ['siren', new FormInfo(false, [Validators.maxLength(9)])],
    ['tvaIntraComm', new FormInfo(false, [Validators.maxLength(15)])],
    ['idActivite', new FormInfo(false, [Validators.required])],
    ['montantMaxAutoValidBC', new FormInfo(true, [])]
  ]),
  EDIT: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(true, [Validators.maxLength(7), Validators.required])],
    ['libelle', new FormInfo(false, [Validators.maxLength(30)])],
    ['codeStar', new FormInfo(false, [Validators.maxLength(6)])],
    ['codeCompta', new FormInfo(false, [Validators.maxLength(12)])],
    ['capitalSocial', new FormInfo(false, [Validators.maxLength(50)])],
    ['rsc', new FormInfo(false, [Validators.maxLength(50)])],
    ['siren', new FormInfo(false, [Validators.maxLength(9)])],
    ['tvaIntraComm', new FormInfo(false, [Validators.maxLength(15)])],
    ['idActivite', new FormInfo(false, [Validators.required])],
    ['montantMaxAutoValidBC', new FormInfo(true, [])]
  ]),
  VISUALIZE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(true, [Validators.maxLength(7)])],
    ['libelle', new FormInfo(true, [Validators.maxLength(30)])],
    ['codeStar', new FormInfo(true, [Validators.maxLength(6)])],
    ['codeCompta', new FormInfo(true, [Validators.maxLength(12)])],
    ['capitalSocial', new FormInfo(true, [Validators.maxLength(50)])],
    ['rsc', new FormInfo(true, [Validators.maxLength(50)])],
    ['siren', new FormInfo(true, [Validators.maxLength(9)])],
    ['tvaIntraComm', new FormInfo(true, [Validators.maxLength(15)])],
    ['idActivite', new FormInfo(true, [Validators.required])],
    ['montantMaxAutoValidBC', new FormInfo(true, [])]
  ])
};
